import Masonry from 'react-masonry-css';
import InfiniteScroll from 'react-infinite-scroll-component';

import {
  FlyerCard,
  LoadingSpinner,
} from '@/components';

import { MasonryBreakpointCols, } from '@/config/constants';
import { FlyerCardThumbnail } from '@/graphql/types';

type Props = {
  trackId: string;
  flyers: FlyerCardThumbnail[];
  total: number;
  nextPage: () => void;
  onFavoriteFlyer: (flyerId: number) => void;
  audienceId?: string;
  districtId?: string | null;
}

export const FlyerList: React.FC<Props> = ({
  trackId,
  flyers,
  total,
  nextPage,
  onFavoriteFlyer,
  audienceId,
  districtId
}) => {
  const flyersLength = flyers.length;
  const hasMore = flyersLength < total;

  if (flyers.length === 0) return null;

  return (
    <InfiniteScroll
      style={{ margin: '16px 0px 24px' }}
      dataLength={flyersLength}
      next={nextPage}
      hasMore={hasMore}
      scrollThreshold={0.6}
      loader={<LoadingSpinner />}
    >
      <Masonry
        breakpointCols={MasonryBreakpointCols}
        className="my-masonry-grid"
        columnClassName="my-masonry-grid_column"
      >
        {flyers.map(
            ({
              flyerId,
              frontImageUrl,
              isFavorite,
              title,
              criticalDate,
              isRead,
              email,
              pages
            }) => (
              <FlyerCard
                key={flyerId}
                id={flyerId}
                title={title}
                thumbnail={frontImageUrl}
                isFavorite={isFavorite}
                onFavoriteFlyer={onFavoriteFlyer}
                trackId={trackId}
                criticalDate={criticalDate}
                isRead={isRead}
                audienceId={audienceId}
                districtId={districtId}
                email={email}
                ocrText={
                  pages && pages[0] ? pages[0].ocrText : ''
                }
              />
            ),
          )}
      </Masonry>
    </InfiniteScroll>
  )
};
